import './CodePenIframe.scss';

export const CodePenIframe = ({
    user = '',
    title = '',
    hash = '',
    codePenFrame = ''
}) => {
    const baseHrefCodePen = `https://codepen.io/${user}/embed/${hash}`;
    // Codepen's Properties
    const codePenHeight = `height=${codePenFrame.height}`;
    const codePenThemeId = `theme-id=${codePenFrame.themeId}`;
    const codePenDefaultTab = `default-tab=${codePenFrame.defaultTab}`;
    const codepenProperties = `${codePenHeight}&${codePenThemeId}&${codePenDefaultTab}`;
    const codePenFrameSrc = `${baseHrefCodePen}?${codepenProperties}`

    return (
        <iframe
            height={codePenFrame.height}
            width={codePenFrame.width}
            scrolling={codePenFrame.scrolling}
            title={title}
            frameBorder={"no"}
            src={codePenFrameSrc}
            loading={codePenFrame.loading}
            allowtransparency={codePenFrame.allowtransparency}
            className="codepeniframe"
        ></iframe>
    )
}